import convertAddresses from './convertAddress';
import { addressWork, addressHome, addressOther } from 'containers/pages/users/data';
import * as TY from 'containers/pages/users/constants';

/**
 * @function convertFromContactToUserObj
 * @param { object } contact
 * @param { Array } companies
 * @param { Array } contactTypes
 * @param { Array } languages
 * @returns { object } userObj
 */
function convertFromContactToUserObj(contact, companies, contactTypes, languages) {
	let converted = null;
	let _languages = null;

	const hasAddressId = contact.addressIds?.length > 0;
	const hasLanguage = contact.languageIds?.length > 0;

	const _companies = companies.filter((company) => contact.Customers.includes(company.Id));
	const accessOptions = [{ RowNumber: '0', Id: '0', Name: TY.ALL_COMPANIES }, ..._companies];
	const _contactTypes = contactTypes.filter((type) => contact.ContactTypes.includes(type.Id));

	if (hasAddressId) {
		converted = convertAddresses(contact);
	}

	if (hasLanguage) {
		_languages = languages.filter((language) => contact.languageIds.includes(language.id));
	}

	const userObj = {
		[TY.ID]: contact.UserId,
		[TY.CONTACT_ID]: contact.Id,
		[TY.F_NAME]: contact.FirstName,
		[TY.L_NAME]: contact.LastName,
		[TY.COMPANIES]: _companies,
		[TY.IMAGE]: { file: '', name: '', preview: contact?.Image, id: contact?.VFileId },
		[TY.EMAIL_WORK]: contact.WorkEmail,
		[TY.EMAIL_PERSONAL]: contact.PersonalEmail,
		[TY.EMAIL_OTHER]: contact.OtherEmail,
		[TY.CONTACT_TYPES]: _contactTypes,
		[TY.PHONE_WORK]: {
			number: contact.WorkPhone,
			dialCode: contact.WorkPhoneDialCode,
			countryCode: contact.WorkphoneCountryCode,
			ext: contact.WorkPhoneExt,
		},
		[TY.PHONE_MOBILE]: {
			number: contact.CellPhone,
			dialCode: contact.CellPhoneDialCode,
			countryCode: contact.CellPhoneCountryCode,
			ext: contact.CellPhoneExt,
		},
		[TY.PHONE_OTHER]: {
			number: contact.HomePhone,
			dialCode: contact.HomePhoneDialCode,
			countryCode: contact.HomePhoneCountryCode,
			ext: contact.HomePhoneExt,
		},
		[TY.NOTE]: contact.Note,
		[TY.ADDRESS_WORK]: hasAddressId ? converted.addressWork : addressWork,
		[TY.ADDRESS_HOME]: hasAddressId ? converted.addressHome : addressHome,
		[TY.ADDRESS_OTHER]: hasAddressId ? converted.addressOther : addressOther,
		[TY.LANGUAGES]: hasLanguage ? _languages : [],
		[TY.U_NAME]: '',
		[TY.PWD]: '',
		[TY.CONFIRM_PWD]: '',
		[TY.IS_ENABLED]: true,
		[TY.MST_CUST_ID]: '',
		[TY.ACCESS_OPTIONS]: accessOptions,
		[TY.ROLES]: [],
	};
	return userObj;
}

export default convertFromContactToUserObj;
